/**
 * Reason-cell renderer for the Holds table (util A).
 *
 * Returns the most useful single identifier to show inline plus the full
 * pretty-printed payload for the hover popover. Tolerant of a missing or
 * malformed reason — the wallet `HoldResponse` does not currently carry a
 * `reason` field, so this degrades to `—` until the wallet team adds it.
 *
 * Precedence for the inline value:
 *   reason.transaction_id → reason.reference_id → reason.type → '—'
 *
 * @param {unknown} reason
 * @returns {{ primary: string, fullJson: string }}
 */
export function formatReason(reason) {
  const EMPTY = { primary: "—", fullJson: "" };

  if (reason === null || typeof reason !== "object" || Array.isArray(reason)) {
    return EMPTY;
  }

  const primary =
    pickString(reason.transaction_id) ||
    pickString(reason.reference_id) ||
    pickString(reason.type) ||
    "—";

  let fullJson = "";
  try {
    fullJson = JSON.stringify(reason, null, 2);
  } catch (_e) {
    fullJson = "";
  }

  return { primary, fullJson };
}

function pickString(value) {
  if (typeof value === "string" && value.trim() !== "") return value;
  if (typeof value === "number") return String(value);
  return "";
}
